export const arrayify = <T>(value: T | T[]): T[] =>
  Array.isArray(value) ? [...value] : [value];
